
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as tosmSfe6w11ioy7gPFGF9x_6Qiktq0pdLtuEzK0IbO9VUUMeta } from "/root/jwlplanthire/pages/tos.vue?macro=true";
import { default as index5IigtREgzsibf34Ag4lK3eWjdo2FMm1wYADwgdFmWz4Meta } from "/root/jwlplanthire/pages/index.vue?macro=true";
import { default as browseyiNfjYEu0346mU6_45VKE_hwlf4OIwuxUnXKKAayhzHh8Meta } from "/root/jwlplanthire/pages/browse.vue?macro=true";
import { default as contactCO_PsAFnjjIw9l2Z0VOHuMR5WlqZeLXduuro3YddK4cMeta } from "/root/jwlplanthire/pages/contact.vue?macro=true";
import { default as reviewsOWCwK8_BT90jYQX9RNjI3Xs0f2EcB9ZwD5CSaNjCKZkMeta } from "/root/jwlplanthire/pages/reviews.vue?macro=true";
import { default as _91_46_46_46all_935BJ_KioZjMNaYc5v201XKB5ZfGYcYr_i0f9O6TneT_cMeta } from "/root/jwlplanthire/pages/[...all].vue?macro=true";
import { default as _91_46_46_46id_93psqtRQ_b8IN9_b7CwPQj5mtSruRatzEnCMNRcO2Jfk8Meta } from "/root/jwlplanthire/pages/machine/[...id].vue?macro=true";
import { default as _91location_937b_45pB1wl_453ITkOEHP5NIRNaeZdMAwBjbrVMOYaVpV9EMeta } from "/root/jwlplanthire/pages/[route]/[location].vue?macro=true";
export default [
  {
    name: "tos",
    path: "/tos",
    meta: tosmSfe6w11ioy7gPFGF9x_6Qiktq0pdLtuEzK0IbO9VUUMeta || {},
    component: () => import("/root/jwlplanthire/pages/tos.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index5IigtREgzsibf34Ag4lK3eWjdo2FMm1wYADwgdFmWz4Meta || {},
    component: () => import("/root/jwlplanthire/pages/index.vue")
  },
  {
    name: "browse",
    path: "/browse",
    meta: browseyiNfjYEu0346mU6_45VKE_hwlf4OIwuxUnXKKAayhzHh8Meta || {},
    component: () => import("/root/jwlplanthire/pages/browse.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactCO_PsAFnjjIw9l2Z0VOHuMR5WlqZeLXduuro3YddK4cMeta || {},
    component: () => import("/root/jwlplanthire/pages/contact.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    meta: reviewsOWCwK8_BT90jYQX9RNjI3Xs0f2EcB9ZwD5CSaNjCKZkMeta || {},
    component: () => import("/root/jwlplanthire/pages/reviews.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    meta: _91_46_46_46all_935BJ_KioZjMNaYc5v201XKB5ZfGYcYr_i0f9O6TneT_cMeta || {},
    component: () => import("/root/jwlplanthire/pages/[...all].vue")
  },
  {
    name: "machine-id",
    path: "/machine/:id(.*)*",
    meta: _91_46_46_46id_93psqtRQ_b8IN9_b7CwPQj5mtSruRatzEnCMNRcO2Jfk8Meta || {},
    component: () => import("/root/jwlplanthire/pages/machine/[...id].vue")
  },
  {
    name: "route-location",
    path: "/:route()/:location()",
    meta: _91location_937b_45pB1wl_453ITkOEHP5NIRNaeZdMAwBjbrVMOYaVpV9EMeta || {},
    component: () => import("/root/jwlplanthire/pages/[route]/[location].vue")
  }
]